import { Eip6963Adapter } from "./eip6963";
export default new Eip6963Adapter("com.trustwallet.app");
